<template>
    <v-dialog
        :value="isOpen"
        max-width="700px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Dodaj nową etykietę
                </h1>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="2" sm="2" md="2">
                            <v-text-field
                                v-model="itemData.number"
                                label="Numer"
                                :rules="numberRules"
                                @change="isTouch = true"
                            />
                        </v-col>
                        <v-col cols="10" sm="10" md="10">
                            <v-text-field
                                v-model="itemData.name"
                                label="Nazwa"
                                :rules="nameRules"
                                @change="isTouch = true"
                            />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                v-model="itemData.shop"
                                label="Sklep"
                                :rules="shopRules"
                                @change="isTouch = true"
                            />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                v-model="itemData.city"
                                label="Miasto"
                                :rules="cityRules"
                                @change="isTouch = true"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose()"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :disabled="!canSave"
                    @click="addLabelsToList()"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import _ from 'lodash'
import { required, integer, minValue } from 'vuelidate/lib/validators'
import { isInteger } from '@/utils/customValidators'

export default {
    name: 'AddEditLabelsWithCityDialog',
    props: {
        item: {
            type: Object,
            default: () => {}
        },
        isOpen: {
            type: Boolean
        },
    },
    data() {
        return {
            itemData: {
                id: null,
                number: null,
                name: null,
                shop: null,
                city: null,
            },
            isTouch: false,
        }
    },
    validations: {
        itemData: {
            number: {
                required,
                integer,
                minValue: minValue(0),
            },
            name: {
                required,
            },
            shop: {
                required,
                integer,
                minValue: minValue(0),
            },
            city: {
                required,
            },
        }
    },
    computed: {
        canSave() {
            return !this.$v.$invalid
        },
        numberRules() {
            return this.integerRules(this.itemData.number)
        },
        nameRules() {
            return this.withTrimRules(this.itemData.name)
        },
        shopRules() {
            return this.integerRules(this.itemData.shop)
        },
        cityRules() {
            return this.withTrimRules(this.itemData.city)
        },
    },
    watch: {
        isOpen(value) {
            if (value) {
                this.itemData = {
                    id: this.item.id,
                    number: this.item.number,
                    name: this.item.name?.trim(),
                    shop: this.item.shop,
                    city: this.item.city?.trim(),
                }
                this.isTouch = false
            }
        },
    },
    methods: { 
        onClose() {
            this.$emit('on-close')
            setTimeout(() => {
                this.itemData = {
                    number: null,
                    name: null,
                    shop: null,
                    city: null,
                }
            }, 500)
        },
        addLabelsToList() {
            this.$v.$touch()

            if (!this.$v.$invalid) {
                this.$emit('on-save', this.itemData)
                this.onClose()
            }
        },
        withTrimRules(field) {
            if (!this.isTouch) return []
            if (
                (typeof field == 'string' && field.trim() === '') ||
                field === null || field === undefined
            ) {
                return ['To pole jest wymagane']
            }

            return []
        },
        integerRules(field) {
            const rules = []
        
            if (!this.isTouch) return []
            if (field === '' || field === null || field === undefined) {
                rules.push('To pole jest wymagane')
            } else if (
                !isInteger(field) || !_.inRange(field, 0, Infinity)
            ) {
                rules.push('Nieprawidłowy format')
            }
            
            return rules
        }
    }
}
</script>